import { render, staticRenderFns } from "./piece-tab.vue?vue&type=template&id=21dc72a2"
import script from "./piece-tab.vue?vue&type=script&lang=js"
export * from "./piece-tab.vue?vue&type=script&lang=js"
import style0 from "./piece-tab.vue?vue&type=style&index=0&id=21dc72a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports